import { Provider } from '@angular/core';
import { FichaFinanceiraService } from '../../../../folha-pagamento/src/calculo/ficha-financeira.service';
import { ArquivoStorageService } from '../../../../folha-pagamento/src/common/services/arquivo-storage.service';
import { FileService } from '../../../../folha-pagamento/src/common/services/file.service';
import { PericiaAfastamentoService } from '../../../../folha-pagamento/src/common/services/pericia-afastamento.service';
import { ExportReportService } from '../../../../folha-pagamento/src/export-report/export-report.service';
import { HistoricoFuncionarioService } from '../../../../folha-pagamento/src/historico-funcionario/historico-funcionario.service';
import { MovimentacaoAfastamentoService } from '../../../../folha-pagamento/src/movimentacao-pessoal/movimentacao-afastamento.service';
import {
  MovimentacaoRedutorCargaHorariaService
} from '../../../../folha-pagamento/src/movimentacao-pessoal/movimentacao-redutor-carga-horaria/movimentacao-redutor-carga-horaria.service';
import { ProgramacaoFeriasService } from '../../../../folha-pagamento/src/programacao-ferias/programacao-ferias.service';
import { PortalArquivoStorageService } from './portal-arquivo-storage.service';
import { PortalExportReportService } from './portal-export-report.service';
import { PortalFichaFinanceiraService } from './portal-ficha-financeira.service';
import { PortalFileService } from './portal-file.service';
import { PortalHistoricoFuncionarioService } from './portal-historico-funcionario.service';
import { PortalMovimentacaoAfastamentoService } from './portal-movimentacao-afastamento.service';
import { PortalMovimentacaoRedutorCargaHorariaService } from './portal-movimentacao-redutor-carga-horaria.service';
import { PortalPericiaAfastamentoService } from './portal-pericia-afastamento.service';
import { PortalProgramacaoFeriasService } from './portal-programacao-ferias.service';

/**
 * Troca, dentro do Portal do Servidor, os services do folha que chamam endpoints genéricos (relatório, storage e dados
 * funcionais) pelos que chamam as rotas do portal, que validam se o recurso é do servidor logado. Precisa ser declarado no
 * `providers` de cada módulo lazy, porque os providers dos módulos do folha importados (ex.: ExportReportModule) entram no
 * injector do módulo lazy.
 */
export const PORTAL_SERVIDOR_PROVIDERS: Provider[] = [
  { provide: ExportReportService, useClass: PortalExportReportService },
  { provide: ArquivoStorageService, useClass: PortalArquivoStorageService },
  { provide: FileService, useClass: PortalFileService },
  { provide: HistoricoFuncionarioService, useClass: PortalHistoricoFuncionarioService },
  { provide: MovimentacaoAfastamentoService, useClass: PortalMovimentacaoAfastamentoService },
  { provide: MovimentacaoRedutorCargaHorariaService, useClass: PortalMovimentacaoRedutorCargaHorariaService },
  { provide: PericiaAfastamentoService, useClass: PortalPericiaAfastamentoService },
  { provide: ProgramacaoFeriasService, useClass: PortalProgramacaoFeriasService },
  { provide: FichaFinanceiraService, useClass: PortalFichaFinanceiraService },
];
